import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from '../../application/use-cases/auth/AuthContext';

interface PrivateRouteProps {
  path: string;
  children: React.ReactNode;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ path, children }) => {
  const { isAuthenticated } = useAuth();
  return (
    <Route
      path={path}
      render={() => (isAuthenticated ? children : <Redirect to="/login" />)}
    />
  );
};

export default PrivateRoute;
